module.exports = __webpack_public_path__ + "img/r4.d8d54a3e.png";